module.exports = __webpack_public_path__ + "static/media/acceptCall.1bce41d5.svg";